<template>
  <v-app>
    <Header v-if="autenticado"></Header>
    <Navbar :roles="roles"></Navbar>
    <InfoEmpresa :empresa="empresaSeleccionada" v-if="empresaSeleccionada"></InfoEmpresa>
    <!-- Rastro de migas -->
    <RastroMigas :items="breadcrumb"></RastroMigas>
    <AppMain></AppMain>
    <v-footer color="blue-grey darken-4" height="60" app>
      <Footer></Footer>
    </v-footer>
    <Loading id="loadingWdg" :modalShow="loading"></Loading>
  </v-app>
</template>

<script>
import { Header, AppMain, Footer, Navbar, InfoEmpresa, RastroMigas } from './components';
import { Loading } from '@/components';
import { mapGetters } from 'vuex';
export default {
  name: 'Layout',
  components: {
    Header,
    AppMain,
    Footer,
    Navbar,
    InfoEmpresa,
    RastroMigas,
    Loading
  },
  computed: {
    ...mapGetters({
      userName: 'userName',
      empresaSeleccionada: 'empresaSelected',
      breadcrumb: 'breadcrumb',
      activeIndex: 'menuSelected',
      roles: 'roles',
      browserInfo: 'browserInfo',
      autenticado: 'userAuthenticated',
      rolesUsuario: 'rolesUsuario',
      loading: 'loading'
    })
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.theme--light.application {
  background-color: transparent !important;
}
</style>
